/** @format */

import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { Col, Divider, Row } from "antd";
import ConditionalRoute from "../../components/ConditionalRoute";
import CreatePasswordContent from "../../content/CreatePasswordContent";
import { IAppRouterProps } from "./AppRouter.types";
import LoginContent from "../../content/LoginContent";
import MainContent from "../../content/MainContent";
import PageNotFoundContent from "../../content/PageNotFoundContent";
import React from "react";
import TermsOfServiceContent from "../../content/TermsOfServiceContent";
import AccountInfoPage from "../../content/MainContent/AccountInfoPage";
import { INavBarProps } from "../NavBar/NavBar.types";
import NavBar from "../NavBar";
import RegistrationContent from "../../content/RegistrationContentNew";
import PhoneNumbersOverview from "../../content/MainContent/PhoneNumbersOverview";

interface IAppRouterViewProps extends IAppRouterProps {
	navBarProps: INavBarProps;
}

const AppRouterView: React.FC<IAppRouterViewProps> = ({
	isLoggedIn,
	navBarProps,
}) => {
	return (
		<div>
			<BrowserRouter>
				<NavBar {...navBarProps} />
				<Routes>
					<Route
						path="/create-password"
						element={
							<ConditionalRoute doRedirect={isLoggedIn} redirectPathname="/">
								<CreatePasswordContent />
							</ConditionalRoute>
						}
					/>
					<Route
						path="/login"
						element={
							<ConditionalRoute doRedirect={isLoggedIn} redirectPathname="/">
								<LoginContent />
							</ConditionalRoute>
						}
					/>
					{/* <Route
						path="/register"
						element={
							<ConditionalRoute doRedirect={isLoggedIn} redirectPathname="/">
								<RegistrationContent />
							</ConditionalRoute>
						}
					/> */}
					<Route path="/terms-of-service" element={<TermsOfServiceContent />} />
					<Route
						path="/phone-numbers"
						element={
							<ConditionalRoute
								doRedirect={!isLoggedIn}
								redirectPathname="/login">
								<PhoneNumbersOverview />
							</ConditionalRoute>
						}
					/>
					<Route
						path="/account/:id"
						element={
							<ConditionalRoute
								doRedirect={!isLoggedIn}
								redirectPathname="/login">
								<AccountInfoPage />
							</ConditionalRoute>
						}
					/>
					<Route
						path="/"
						element={
							<ConditionalRoute
								doRedirect={!isLoggedIn}
								redirectPathname="/login">
								<MainContent
									sitekey={process.env.REACT_APP_SITE_KEY || ""} // this will probably create a problem
									onSuccess={() => {}} // this will also cause a problem (probably)
								/>
							</ConditionalRoute>
						}
					/>
					<Route path="/*" element={<PageNotFoundContent />} />
				</Routes>
				<Row justify="center" style={{ display: "flex" }}>
					<Col>
						<div style={{ color: "black", marginBottom: "30px" }}>
							Powered by Voiceg<span style={{ color: "#faad14" }}>ai</span>n
						</div>
					</Col>
					<Col>
						<Divider type="vertical" style={{ color: "black" }} />
					</Col>
					<Col>
						<Link to="/terms-of-service">Terms of Service</Link>
					</Col>
				</Row>
			</BrowserRouter>
		</div>
	);
};

export default AppRouterView;
